enum Locale
{
	German = 'de-CH',
	French = 'fr-CH',
	Italian = 'it-CH',
	English = 'en-US'
}

export default Locale;